import React from 'react';
import { RagIndicator } from '@/types/index';

interface IndicatorCardProps {
  indicator: RagIndicator;
}

const getScoreColor = (score: number): string => {
  if (score >= 8) return 'text-green-600 dark:text-green-400';
  if (score >= 6) return 'text-blue-600 dark:text-blue-400';
  if (score >= 4) return 'text-yellow-600 dark:text-yellow-400';
  if (score >= 2) return 'text-orange-600 dark:text-orange-400';
  return 'text-red-600 dark:text-red-400';
};

const getScoreBgColor = (score: number): string => {
  if (score >= 8) return 'bg-green-500';
  if (score >= 6) return 'bg-blue-500';
  if (score >= 4) return 'bg-yellow-500';
  if (score >= 2) return 'bg-orange-500';
  return 'bg-red-500';
};

const getTrendIcon = (trend?: string): string => {
  if (trend === 'hausse') return '\u2197';
  if (trend === 'baisse') return '\u2198';
  return '\u2192';
};

const getTrendColor = (trend?: string): string => {
  if (trend === 'hausse') return 'text-green-500';
  if (trend === 'baisse') return 'text-red-500';
  return 'text-gray-400';
};

export const IndicatorCard: React.FC<IndicatorCardProps> = ({ indicator }) => {
  return (
    <div className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/50">
      {/* Score */}
      <div className="flex-shrink-0 flex flex-col items-center gap-1">
        <span className={`text-lg font-bold ${getScoreColor(indicator.score)}`}>
          {indicator.score}
        </span>
        <div className="w-8 h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full ${getScoreBgColor(indicator.score)}`}
            style={{ width: `${indicator.score * 10}%` }}
          />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-800 dark:text-gray-200">
            {indicator.label}
          </span>
          {indicator.trend && (
            <span className={`text-xs ${getTrendColor(indicator.trend)}`}>
              {getTrendIcon(indicator.trend)}
            </span>
          )}
        </div>
        {indicator.value != null && (
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            {indicator.value} {indicator.unit || ''}
          </div>
        )}
        {indicator.comment && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-relaxed">
            {indicator.comment}
          </p>
        )}
      </div>
    </div>
  );
};
